import React from "react";

// eslint-disable-next-line
import "swiper/css/bundle";
import "./Client/Swiper/style.css";
import Apps from "./Client/Routes/Apps";
import { ToastContainer } from "react-toastify";
import { QueryClient, QueryClientProvider } from "react-query";

function Apping() {
  const queryClient = new QueryClient();

  return (
    <div>
      <QueryClientProvider client={queryClient}>
        <Apps />
        <ToastContainer />
      </QueryClientProvider>
    </div>
  );
}

export default Apping;
